var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack231({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.53,3.93H6.26V8.58A8.56,8.56,0,0,0,6.33,10a1.4,1.4,0,0,0,.53.85A1.86,1.86,0,0,0,8,11.19a1.7,1.7,0,0,0,1.12-.31,1.16,1.16,0,0,0,.45-.74,10,10,0,0,0,.07-1.46V3.93h1.74V8.44a12,12,0,0,1-.14,2.19,2.53,2.53,0,0,1-.52,1.08,2.72,2.72,0,0,1-1,.7,4.45,4.45,0,0,1-1.65.26,4.74,4.74,0,0,1-1.87-.29,2.77,2.77,0,0,1-1-.73,2.48,2.48,0,0,1-.48-1,9.92,9.92,0,0,1-.17-2.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack231);
export default __webpack_public_path__ + "static/media/Symbolpack_2_31.0af03bc74e780e5d055cf53581095c93.svg";
export { ForwardRef as ReactComponent };